var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxSize ba b--light-gray pointer",class:{'bg-yellow' : _vm.clicked},on:{"click":_vm.clickEvents}},[(_vm.clicked)?_c('img',{attrs:{"src":require("@/assets/img/icon_check_simple.svg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }